<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

// 假設這是觸發購物車的按鈕選擇器
const cartButton = document.querySelector('#shopify-section-sections--17180651716706__header_navigation_compact_mf48t9 > sticky-header > div > div > div.header-icons.header-item.header-item--side.d-flex.flex-align-center.flex-wrap.fs-0 > a.header__icon.header__icon--cart.link.link--text.focus-inset.cart-icon-bubble.pt-5.pb-5.h-100'); // 替換為實際選擇器

if (cartButton) {
    cartButton.addEventListener('click', () => {
        // 使用 setTimeout 延遲執行，以確保 DOM 已經加載
        setTimeout(() => {
            const targetDiv = document.querySelector('#halo-cart-sidebar > div.halo-sidebar-header.text-left');

            if (targetDiv) {
                // 檢查文本是否已經存在，避免重複插入
                if (!targetDiv.querySelector('.promo-text')) {
                    const newText = document.createElement('div');
                    newText.textContent = '🔥新年限定優惠 免運費 包安裝🔥';
                    newText.className = 'promo-text'; // 添加類名以便檢查
                    newText.style.marginTop = '10px';
                    newText.style.fontSize = '16px';
                    newText.style.color = '#ff0000';
                    newText.style.textAlign = 'center';
                    targetDiv.appendChild(newText);
                }
            }
        }, 300); // 根據需要調整延遲時間
    });
}